export const chatZhCN = {
  chat: {
    lecture: '授课',
    noConversations: '暂无对话',
    startConversation: '输入消息开始对话',
    noMessages: '暂无消息',
    ended: '已结束',
    unknown: '未知',
    stopDiscussion: '结束讨论',
    endQA: '结束问答',
    tabs: {
      lecture: '笔记',
      chat: '对话',
    },
    lectureNotes: {
      empty: '播放课程后，笔记将在此显示',
      emptyHint: '点击播放按钮开始授课',
      pageLabel: '第 {n} 页',
      currentPage: '当前页',
    },
    badge: {
      qa: 'Q&A',
      discussion: '讨论',
      lecture: '授课',
    },
  },
  actions: {
    names: {
      spotlight: '聚光灯',
      laser: '激光笔',
      wb_open: '打开白板',
      wb_draw_text: '白板文本',
      wb_draw_shape: '白板形状',
      wb_draw_chart: '白板图表',
      wb_draw_latex: '白板公式',
      wb_draw_table: '白板表格',
      wb_draw_line: '白板线条',
      wb_clear: '清空白板',
      wb_delete: '删除元素',
      wb_close: '关闭白板',
      discussion: '课堂讨论',
    },
    status: {
      inputStreaming: '等待中',
      inputAvailable: '执行中',
      outputAvailable: '已完成',
      outputError: '错误',
      outputDenied: '已拒绝',
      running: '执行中',
      result: '已完成',
      error: '错误',
    },
  },
  agentBar: {
    readyToLearn: '准备好一起学习了吗？',
    expandedTitle: '课堂角色配置',
    configTooltip: '点击配置课堂角色',
  },
  proactiveCard: {
    discussion: '讨论',
    join: '加入讨论',
    skip: '跳过',
    pause: '暂停',
    resume: '继续',
  },
  voice: {
    startListening: '语音输入',
    stopListening: '停止录音',
  },
} as const;

export const chatEnUS = {
  chat: {
    lecture: 'Lecture',
    noConversations: 'No conversations',
    startConversation: 'Type a message below to begin chatting',
    noMessages: 'No messages yet',
    ended: 'ended',
    unknown: 'Unknown',
    stopDiscussion: 'Stop Discussion',
    endQA: 'End Q&A',
    tabs: {
      lecture: 'Notes',
      chat: 'Chat',
    },
    lectureNotes: {
      empty: 'Notes will appear here after lecture playback',
      emptyHint: 'Press play to start the lecture',
      pageLabel: 'Page {n}',
      currentPage: 'Current',
    },
    badge: {
      qa: 'Q&A',
      discussion: 'DISC',
      lecture: 'LEC',
    },
  },
  actions: {
    names: {
      spotlight: 'Spotlight',
      laser: 'Laser',
      wb_open: 'Open Whiteboard',
      wb_draw_text: 'Whiteboard Text',
      wb_draw_shape: 'Whiteboard Shape',
      wb_draw_chart: 'Whiteboard Chart',
      wb_draw_latex: 'Whiteboard Formula',
      wb_draw_table: 'Whiteboard Table',
      wb_draw_line: 'Whiteboard Line',
      wb_clear: 'Clear Whiteboard',
      wb_delete: 'Delete Element',
      wb_close: 'Close Whiteboard',
      discussion: 'Discussion',
    },
    status: {
      inputStreaming: 'Waiting',
      inputAvailable: 'Executing',
      outputAvailable: 'Completed',
      outputError: 'Error',
      outputDenied: 'Denied',
      running: 'Executing',
      result: 'Completed',
      error: 'Error',
    },
  },
  agentBar: {
    readyToLearn: 'Ready to learn together?',
    expandedTitle: 'Classroom Role Config',
    configTooltip: 'Click to configure classroom roles',
  },
  proactiveCard: {
    discussion: 'Discussion',
    join: 'Join',
    skip: 'Skip',
    pause: 'Pause',
    resume: 'Resume',
  },
  voice: {
    startListening: 'Voice input',
    stopListening: 'Stop recording',
  },
} as const;
